<template>
<div class="nation">
  <top-bar :left="true"></top-bar>
  <van-search v-model="keyword" :placeholder="$t('nation.searchPlaceholder')" />
  <van-index-bar v-if="!keyword.trim()" :sticky="false">
    <van-index-anchor :index="item.initial"  v-for="item in alphabet" :key="item.initial">
      <p class="p">{{item.initial}}</p>
      <van-cell :title="item2.label" v-for="item2 in item.cells" :key="item2.value" @click="onClick(item2)"/>
    </van-index-anchor>
  </van-index-bar>
  <div v-else class="search-list">
    <van-cell :title="item.label" v-for="item in filteredList" :key="item.value" @click="onClick(item)" />
    <van-empty v-if="!filteredList.length" :description="$t('nation.noResult')" />
  </div>
</div>
</template>

<script>
import {getDictTree} from '@/utils/common'
import topBar from '@/components/topBar/topBar.vue'

import { mapMutations } from 'vuex'

export default {
  components: { topBar },
  data() {
    return {
      dictList:[],
      alphabet:[],
      keyword: ''
    }
  },
  computed: {
    filteredList() {
      const kw = this.keyword.trim().toLowerCase()
      if (!kw) return this.dictList
      return this.dictList.filter(ren => (ren.label || '').toLowerCase().includes(kw))
    }
  },
  methods: {
    ...mapMutations,
    getDict() {
      const isEn = this.$lang === 'en-US'
      const http = isEn ? this.$httpCustApp : this.$http
      const url = isEn
        ? http.adornUrl('/wxapp/sys/dict/listDictByCodeEn')
        : http.adornUrl('/wxapp/sys/dict/listDictByCode')

      http({ url, method: 'post', params: http.adornParams({ code: 'nationality' }) }).then(({ data }) => {
        if (data.code == 0) {
          this.dictList = data.dicts.map(d => ({ ...d, value: String(d.value) }))
          this.info()
        }
      })
    },
    info() {
      const isEn = this.$lang === 'en-US'
      const alphabet = []
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach((initial) => {
          const cells = this.dictList.filter((ren) =>
            (isEn ? ren.label : ren.parameter).charAt(0).toUpperCase() === initial
          )
          alphabet.push({ initial, cells })
      })
      this.alphabet = alphabet
    },
    onClick(value) {
      console.log(value);
      this.$store.commit('setNationality', value)
      this.$router.go(-1)
    }
  },
  created() {
    this.getDict()
  }
}
</script>

<style lang="scss" scoped>
  .nation {
    padding-top: 100px;
    .search-list {
      padding: 0 20px;
      .van-cell {
        border-bottom: 1px solid #f0f0f0;
      }
    }
    .p {
      text-align: center;
      background-color: #ccc;
      padding: 0;
      height: 50px;
      line-height: 50px;
      font-size: 30px;
    }
  }
</style>